import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import fa from './fa.json';
import en from './en.json';

const resources = {
    en: {
        translation: en
    },
    fa: {
        translation: fa
    }
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: "fa",
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;